import { Link } from "react-router-dom";
import { Plus, Pencil } from "lucide-react";

import { Button } from "@/components/ui/button";

type EntityButtonMode = "create" | "edit";

interface EntityButtonProps {
  entityName: string;
  mode?: EntityButtonMode;
  to?: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export function EntityButton({
  entityName,
  mode = "create",
  to,
  onClick,
  disabled = false,
  className,
}: EntityButtonProps) {
  const Icon = mode === "create" ? Plus : Pencil;
  const label = mode === "create" ? `New ${entityName}` : `Edit ${entityName}`;

  const buttonContent = (
    <>
      <Icon />
      {label}
    </>
  );

  if (to && !disabled) {
    return (
      <Button asChild size="sm" className={className}>
        <Link to={to}>{buttonContent}</Link>
      </Button>
    );
  }

  return (
    <Button
      size="sm"
      disabled={disabled}
      onClick={onClick}
      className={className}
    >
      {buttonContent}
    </Button>
  );
}
